import {Circle1} from "../../Shapes/Hero/Circle1";
import {Circle2} from "../../Shapes/Hero/Circle2";
import {Dots} from "../../Shapes/Dots/Dots";
import {HeroAdBanner} from "../../common/HeroAdBanner";
import {StitchPicturesButton} from "../../common/StitchPicturesButton/StitchPicturesButton";
import {logFirebaseEvent} from "../../../helpers/firebase_helper";
import sampleImage1 from "../../../../public/static/photojoiner.com-photo-stitch-sample-1.webp";
import Image from "next/image";
import {isMobile} from "react-device-detect";

export interface IStitchFeatureHeroProps {
  backgroundColor: string;
  // imageSrc: string;
  circle1Color: string;
  circle2Color: string;
  dotsColor?: string;
  textColor?: string;
}

export const StitchFeatureHero = ({
  backgroundColor,
  // imageSrc,
  circle1Color,
  circle2Color,
  dotsColor = "#F2994A",
  textColor = "#000",
}: IStitchFeatureHeroProps) => {
  return (
    <div
      className="  pt-4 px-4 xl:px-52  flex flex-col"
      style={{ color: textColor, backgroundColor }}
    >
      <div className="pt-32 flex flex-col lg:flex-row  gap-8 py-8">
        <div className="flex justify-center w-full">
          <div
            className=" flex flex-col gap-8  items-baseline "
            style={{ maxWidth: "65ch" }}
          >
            <div className="flex flex-col text-4xl lg:text-8xl leading-tight  font-medium">
              <h1>Photo Joiner</h1>
            </div>
            <div className="text-2xl ">
              Easily merge photos together. Our Photo Joiner tool makes it easy
              to combine photos horizontally or vertically with just a few
              clicks. Easily adjust canvas size, add multiple photos, and adjust
              the size of each photo.
            </div>
            <StitchPicturesButton
              text="Select Photos"
              onFileSelect={() => {
                logFirebaseEvent("cus_select_photos", {
                  location: "web_stitch",
                });
              }}
            />
          </div>
        </div>

        <div className="w-full flex justify-center pb-10">
          <div className="relative bg-red-500 w-full aspect-[1.18]">
            {/* <img src={imageSrc} className="p-0 ml-0 opacity-0"  alt='PhotoJoiner collage maker editor'/> */}

            <div className="absolute inset-0 z-10">
              <Image src={sampleImage1} alt="PhotoJoiner collage maker editor"

                     width={isMobile ? 500 : 1000}
                     sizes={`max-width: ${isMobile?500:1000}px`}
              />
            </div>

            <div className="hidden lg:block absolute top-0 left-0 -translate-x-1/2 -translate-y-1/3">
              <Circle1 fill={circle1Color} />
            </div>

            <div className="hidden lg:block absolute bottom-20 right-0 translate-y-1/3">
              <Circle2 fill={circle2Color} />
            </div>

            <div className="hidden lg:block absolute top-0 -right-10 -translate-y-1/4 ">
              <Dots fill={dotsColor} />
            </div>

            <div className="hidden lg:block absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4">
              <Dots fill={dotsColor} />
            </div>
          </div>
        </div>
      </div>
      <HeroAdBanner />
    </div>
  );
};
